export const createTopLayerHost = (tagName: string): HTMLElement => {
  const host = document.createElement(tagName);
  host.popover = 'manual';
  Object.assign(host.style, {
    position: 'fixed',
    inset: '0',
    width: 'auto',
    height: 'auto',
    margin: '0',
    padding: '0',
    border: 'none',
    background: 'transparent',
    color: 'inherit',
    overflow: 'visible',
    pointerEvents: 'none',
  });
  return host;
};

export const hideTopLayerHost = (host: HTMLElement): void => {
  if (host.matches(':popover-open')) {
    host.hidePopover();
  }
};

export const raiseTopLayerHost = (host: HTMLElement): void => {
  hideTopLayerHost(host);
  host.showPopover();
};
